import React from 'react';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { getThermostatName, RoomRow } from './templates/RoomRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
};
export const ThermostatRow = ({ manifold }: Props) => {
  return <RoomRow name="Thermostat" manifold={manifold} getValue={getThermostatName} />;
};
